import React, { useState } from 'react';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Auth.css';

export default function Signup() {
  const { user, signup } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/market-news" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    // Client-side checks mirror server validation so we can fail fast without a round trip.
    if (password.length < 8) return setError('Password must be at least 8 characters');
    if (password !== confirm) return setError('Passwords do not match');
    setBusy(true);
    try {
      await signup(username.trim(), password);
      navigate('/market-news', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1 className="auth-title">Create account</h1>
        <p className="auth-subtitle">3–32 chars, password 8+</p>
        <label className="auth-label">
          <span>Username</span>
          <input
            type="text" autoComplete="username" autoFocus required
            pattern="[A-Za-z0-9_-]{3,32}"
            value={username} onChange={e => setUsername(e.target.value)}
          />
        </label>
        <label className="auth-label">
          <span>Password</span>
          <input
            type="password" autoComplete="new-password" required minLength={8}
            value={password} onChange={e => setPassword(e.target.value)}
          />
        </label>
        <label className="auth-label">
          <span>Confirm password</span>
          <input
            type="password" autoComplete="new-password" required minLength={8}
            value={confirm} onChange={e => setConfirm(e.target.value)}
          />
        </label>
        {error && <div className="auth-error">{error}</div>}
        <button type="submit" className="auth-btn" disabled={busy}>
          {busy ? 'Creating…' : 'Create account'}
        </button>
        <p className="auth-foot">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
